<script>
    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';
    import MainConainer from '@/components/container/MainContainer.vue';

    import ButtonAnyNew from '@/components/left-panel/any-button/ButtonAnyNew.vue';
    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

    import AssetTypeList from '@/components/page-asset-type-edit/AssetTypeList.vue';
    import AssetTypeAdd from '@/components/page-asset-type-edit/asset-type-add/AssetTypeAdd.vue';
    import AssetTypeEdit from '@/components/page-asset-type-edit/asset-type-edit/AssetTypeEdit.vue';

    export default {
        components: {
            LeftPanel: LeftPanel,
            RightContainer: RightContainer,
            MainConainer: MainConainer,

            ButtonAnyNew: ButtonAnyNew,
            ButtonReturn: ButtonReturn,

            AssetTypeList: AssetTypeList,
            AssetTypeAdd: AssetTypeAdd,
            AssetTypeEdit: AssetTypeEdit,
        },
        async mounted() {
            this.$store.commit('IS_LOAD', true);
            this.$store.dispatch('CHECK_ASSET_TYPES');
            this.$store.commit('IS_LOAD', false);
        },
        methods: {
            async toggleNewAssetType() {
                const isShow = this.$store.getters.IS_SHOW_ASSET_TYPE_ADD;
                this.$store.dispatch('CHECK_ASSET_TYPE_ADD');
                this.$store.commit('IS_SHOW_ASSET_TYPE_ADD', !isShow);
            }
        }
    }
</script>


<template>
    <AssetTypeAdd />
    <AssetTypeEdit />
    
    <MainConainer>
        <LeftPanel>
            <ButtonAnyNew 
                title="New Asset Type"
                :method="toggleNewAssetType"
            />
            <hr class="left-separator">
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <AssetTypeList />
        </RightContainer>
    </MainConainer>
</template>